module.exports = __webpack_public_path__ + "media/wawa.9bdc765e.mp4";